module.exports = __webpack_public_path__ + "img/master_card.06326032.jpg";